module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-bg-a059f6b6a1f215898a53dc7e9f2e2175.svg";